var map = {
	"./de/buttons.json": 94964,
	"./de/dialogs.json": 30296,
	"./de/elements.json": 66626,
	"./de/music.json": 45430,
	"./de/shortcuts.json": 82206,
	"./el/buttons.json": 10166,
	"./el/dialogs.json": 8670,
	"./el/elements.json": 23752,
	"./el/music.json": 18672,
	"./el/shortcuts.json": 29124,
	"./en/buttons.json": 1084,
	"./en/dialogs.json": 63920,
	"./en/elements.json": 88938,
	"./en/help/help.json": 26266,
	"./en/music.json": 47742,
	"./en/shortcuts.json": 76294,
	"./fr/buttons.json": 96011,
	"./fr/dialogs.json": 64283,
	"./fr/elements.json": 40115,
	"./fr/help/help.json": 34869,
	"./fr/music.json": 56717,
	"./fr/shortcuts.json": 18513,
	"./hr/buttons.json": 16097,
	"./hr/dialogs.json": 33589,
	"./hr/elements.json": 37901,
	"./hr/help.json": 5923,
	"./hr/music.json": 98571,
	"./hr/shortcuts.json": 40923,
	"./it/buttons.json": 73410,
	"./it/dialogs.json": 1458,
	"./it/elements.json": 44028,
	"./it/help/help.json": 49140,
	"./it/music.json": 79956,
	"./it/shortcuts.json": 92392,
	"./sl/buttons.json": 52692,
	"./sl/dialogs.json": 16664,
	"./sl/elements.json": 45538,
	"./sl/music.json": 72022,
	"./sl/shortcuts.json": 18878,
	"./zh-Hans/buttons.json": 62772,
	"./zh-Hans/dialogs.json": 41944,
	"./zh-Hans/elements.json": 69506,
	"./zh-Hans/music.json": 76726,
	"./zh-Hans/shortcuts.json": 24990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84649;